import React from 'react'
import ReactDOM from 'react-dom/client'

import {createStore} from 'redux';
import {Provider} from 'react-redux';
import reducer from './reducers';

import App from './Components/App'
import {CssBaseline} from "@mui/material";

import Api from './services/Api';
import User from './services/User';
import Directory from './services/Directory';
import Route from './services/Route';
import Geozone from './services/Geozone';

//Потому что это очень специальные классы, которые при создании своего экземпляра селят его в редаксе. Больше от 

//import './shared/config/dayJsConfigUTC'

const store = createStore(reducer);

new Api(store);
new User(store);
new Directory(store);
new Route(store);
new Geozone(store);




ReactDOM.createRoot(document.getElementById('root')).render(
    <Provider store={store} stabilityCheck="never">
        <CssBaseline />
        <App />
    </Provider>
)
